module.exports = __webpack_public_path__ + "img/EnterpriseWeChatQRcode.e6e55a4e.jpg";